export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const SET_IS_USER_MENU_EXTENDED = 'SET_IS_USER_MENU_EXTENDED';
export const SET_IS_SETTINGS_PANEL_OPEN = 'SET_IS_SETTINGS_PANEL_OPEN';
export const SET_IS_LOADING = 'SET_IS_LOADING';
